import CloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import Button from '@/common/components/base/button/Button.tsx';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { rejectTheDocumentQueryOptions } from '@/common/queries/rejectTheDocument/rejectTheDocumentQueryOptions';
import { RejectFileModalProps } from '@/modules/FileList/components/modals/rejectFileModals/RejectFileModal.type.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { css } from 'styled-system/css';
import { Box, Flex, Stack } from 'styled-system/jsx';

export default ({ open, closeModal, fileId }: RejectFileModalProps) => (
  <MainModal open={open} closeModal={closeModal}>
    <RejectFileModal closeModal={closeModal} fileId={fileId} />
  </MainModal>
);

const RejectFileModal = ({
  closeModal,
  fileId,
}: Pick<RejectFileModalProps, 'closeModal'> & { fileId?: number }) => {
  const [description, setDescription] = useState('');
  const methods = useForm<{ description: string; other_reasons?: string }>({
    mode: 'onChange',
  });
  const watcher = useWatch({ control: methods.control, name: 'other_reasons' });
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['my-files'] });
    },
    ...rejectTheDocumentQueryOptions({
      id: fileId ?? 0,
      description: description !== 'دلایل دیگر' ? description : (watcher ?? ''),
    }),
  });
  const [toggleReject, setToggleReject] = useState(false);
  return (
    <Stack gap="20px" alignItems="center">
      {!toggleReject && (
        <>
          <CloseIcon />
          <Typography>آیا از رد پرونده مطمئن هستید؟</Typography>
          <Typography color="black-3" textStyle="b2">
            در صورت رد، پرونده به بخش پرونده‌های انصراف از کارشناسی منتقل می
            شود.
          </Typography>
          <Flex my="20px" w="100%" gap="15px">
            <Button
              onClick={closeModal}
              variant="outlined"
              color="common"
              fullWidth
            >
              انصراف
            </Button>
            <Button
              color="danger"
              fullWidth
              onClick={() => setToggleReject(true)}
            >
              رد پرونده
            </Button>
          </Flex>
        </>
      )}
      {toggleReject && (
        <Box
          width={'100%'}
          display={'flex'}
          flexDirection={'column'}
          textAlign={'right'}
        >
          <Typography>دلیل رد پرونده را انتخاب کنید: </Typography>
          <FormProvider {...methods}>
            <Flex direction={'column'}>
              <RadioGroup
                name="officerType"
                options={[
                  { value: 'نداشتن زمان کافی', label: 'نداشتن زمان کافی' },
                  { value: 'مسافت طولانی', label: 'مسافت طولانی' },
                  {
                    value: 'کافی نبودن اطلاعات پرونده',
                    label: 'کافی نبودن اطلاعات پرونده',
                  },
                  { value: 'دلایل دیگر', label: 'دلایل دیگر' },
                ]}
                renderRadioButton={(component) => component}
                className={css({
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                })}
                onChange={(_, value) => {
                  setDescription(value as string);
                }}
              />
              {description === 'دلایل دیگر' ? (
                <TextInput
                  name="other_reasons"
                  placeholder="توصیحات تکمیلی را وارد کنید"
                />
              ) : null}
            </Flex>
          </FormProvider>

          <Flex my="20px" w="100%" gap="15px">
            <Button
              onClick={closeModal}
              variant="outlined"
              color="common"
              fullWidth
            >
              انصراف
            </Button>
            <Button
              color="primary"
              fullWidth
              onClick={() => {
                mutate({ id: fileId ?? 0, description });
              }}
            >
              ثبت
            </Button>
          </Flex>
        </Box>
      )}
    </Stack>
  );
};
